/**
 * Legend position relative to the chart area.
 * @see https://www.chartjs.org/docs/latest/configuration/legend.html#position
 */
export type BdChartLegendPosition = 'top' | 'left' | 'bottom' | 'right';

/**
 * Alignment of the legend within its position.
 * @see https://www.chartjs.org/docs/latest/configuration/legend.html#align
 */
export type BdChartLegendAlign = 'start' | 'center' | 'end';

/**
 * Configuration options for Chart.js legend.
 * @see https://www.chartjs.org/docs/latest/configuration/legend.html
 */
export interface BdChartLegendOptions {
  /**
   * Controls visibility of the legend.
   * @default true
   */
  display: boolean;

  /**
   * Position of the legend relative to the chart.
   * @default 'top'
   */
  position?: BdChartLegendPosition;

  /**
   * Alignment of the legend within its position.
   * @default 'center'
   */
  align?: BdChartLegendAlign;

  /**
   * Legend title text. When set, title.display is automatically enabled.
   */
  title?: string;
}

/**
 * Default legend options.
 */
export const BD_CHART_LEGEND_OPTIONS_DEFAULT: BdChartLegendOptions = {
  display: true,
  position: 'top',
  align: 'center',
};
